/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc
 */

export const getStandardizedInstallTypeRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc',
  rpcName: 'getStandardizedInstallType',
  auth: 'app',
  fingerprint: '24vr6NNv6Ln_VyaMjYI-G8-jni124OBK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateStandardizedInstallTypeForDraftListingRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc',
  rpcName: 'updateStandardizedInstallTypeForDraftListing',
  auth: 'app',
  fingerprint: 'KTB_K5SBsQz_VyaMjYI-G8-jni124OBK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};